import gql from "graphql-tag";
import ProjectWasteTypeCustomFragment from "./ProjectWasteTypeCustomFragment";

const ProjectWasteMappingFragment = gql`
  fragment projectWasteMapping on projectWasteMapping {
    id
    label
    materialId
    materialWasteTypeId
    pickupDate
    customWeight
    materialWeightSnapshot

    customWasteType {
      id
      label
    }
  }
  ${ProjectWasteTypeCustomFragment}
`;

export default ProjectWasteMappingFragment;
